import React, { useEffect, useState } from "react";
import './App.css';
import './Zero.css';

import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const containerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 20px',
};

const leftColumnStyle = {
  flex: '1',
  marginRight: '20px',
};

const rightColumnStyle = {
  flex: '3',
};

const ChatHeader = () => {
  useEffect(() => {
    document.title = "Admin";
  }, []);
  return (
    <>
      <Typography variant="h4" align="center" gutterBottom>
        Admin Page
      </Typography>
    </>
  )
}

const mockMessages = [];

function App() {
  const [sessions, setSessions] = useState([]);
  const [chatMessages, setChatMessages] = useState(mockMessages);
  const [querySessionId, setQuerySessionId] = useState('');
  const [queryChatId, setQueryChatId] = useState('');
  const [queryStudentId, setQueryStudentId] = useState('');
  const [showSessionInfo, setShowSessionInfo] = useState(false); // Track whether to show session info
  const [studentIdFilter, setStudentIdFilter] = useState(''); // State for student_id filter
  const [isMessageListViewed, setIsMessageListViewed] = useState(false); // Track whether message list is viewed
  const params = useParams(); // for admin_key

  const SessionList = ({ sessions }) => {
    const filteredSessions = sessions.filter(session => session.student_id.includes(studentIdFilter));
    const formatAddTime = (addTime) => {
      const options = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false};
      return new Date(addTime).toLocaleDateString('en-US', options).replace(',', '');
    };
    return (
      <ul>
        {filteredSessions.map((sessionElement) => (
          <li key={sessionElement.session_id}>
            {/* {`Session ID: ${sessionElement.session_id},`} */}
            {/* {`${sessionElement.add_time}, `} */}
            {`${sessionElement.student_id}, `}
            {`${formatAddTime(sessionElement.add_time)}, `}
            
            <button
              onClick={() => {
                getData(
                  'check_session',
                  sessionElement.session_id,
                  sessionElement.chat_id,
                  sessionElement.student_id
                );
                setShowSessionInfo(true); // Show session info on button click
                setIsMessageListViewed(false); // Reset message list view
              }}
            >
              view
            </button>
          </li>
        ))}
      </ul>
    );
  };

  const MessageList = ({ chatMessages }) => {
    const [refreshCount, setRefreshCount] = useState(0); // Add a state to force refresh
    const [refreshParams, setRefreshParams] = useState(null); // Store parameters for refreshing
  
    const handleRefresh = () => {
      setRefreshParams({
        dataType: 'check_session',
        session_id: querySessionId,
        chat_id: queryChatId,
        student_id: queryStudentId
      });
      setRefreshCount(refreshCount + 1); // Increment refresh count to force refresh
    };
  
    useEffect(() => {
      if (refreshParams) {
        getData(refreshParams.dataType, refreshParams.session_id, refreshParams.chat_id, refreshParams.student_id);
      }
    }, [refreshParams]);
  
    return (
      <div>
        {showSessionInfo && (
          <div>
            {`session_id: ${querySessionId}`}<br />
            {`chat_id: ${queryChatId}`}<br />
            {`student_id: ${queryStudentId}`}<br />
            <button onClick={handleRefresh}>Refresh</button>
          </div>
        )}
        {isMessageListViewed && chatMessages.length === 0 && <p></p>}
        <ul>
          {chatMessages.map((messageElement) => (
            <li key={messageElement.id}>{`${messageElement.role}:  ${messageElement.content}`} </li>
          ))}
        </ul>
      </div>
    );
  };
  const getData = (dataType = '', session_id = '', chat_id = '', student_id = '') => {
    console.log('getData');
    setQuerySessionId(session_id);
    setQueryChatId(chat_id);
    setQueryStudentId(student_id);
    const apiUrl = "/admin_handler";
    //const apiUrl = "http://127.0.0.1:8000/admin_handler"; //local testing
    // const apiUrl = "https://17talk.xyz:8443/admin_handler"; // server testing 
    // const apiUrl = "https://17talk.xyz/admin_handler"; // production

    let admin_key;
    if (params.hasOwnProperty('admin_key') && typeof params.admin_key === 'string') {
      admin_key = params.admin_key;
      console.log("admin_key " + admin_key);
    } else {
      console.log('invalid admin_key');
      return;
    }

    let bodyMsg = {
      data_type: dataType,
      session_id: session_id,
      chat_id: chat_id,
      student_id: student_id,
      admin_key: admin_key
    }

    // Send the text message to the backend
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyMsg),
    };

    fetch(apiUrl, requestOptions)
      .then((api_response) => api_response.json())
      .then((data) => {
        let response = JSON.parse(data.body);
        if (dataType === 'session_list') {
          setSessions(response.data);
        } else {
          console.log('dataType not session_list ' + dataType)
          setChatMessages(response.data);
          setIsMessageListViewed(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <>
      <ChatHeader />
      <div style={containerStyle}>
        <div style={leftColumnStyle}>
          <input 
            type="text" 
            placeholder="Filter by student_id" 
            value={studentIdFilter} 
            onChange={(e) => setStudentIdFilter(e.target.value)} 
          />
          <button
            onClick={() => {
              getData('session_list', '', '', studentIdFilter); // Pass student_id filter to getData function
              setShowSessionInfo(false); // Hide session info when "Get sessions" is clicked
              setIsMessageListViewed(false); // Reset message list view
            }}>
            Get sessions
          </button>
          <SessionList sessions={sessions} />
        </div>
        <div style={rightColumnStyle}>
          <MessageList chatMessages={chatMessages} />
        </div>
      </div>
    </>
  )
}

export default App;